<template>
	<div class="form-group">
    <label class="form-label">Extras</label>
    <div class="input-group">
      <input type="text" class="form-control" name="credentials" v-model="extrasType" placeholder="Enter Type">
      <input type="text" class="form-control" name="credentials" v-model="extrasValue" placeholder="Enter Value">
      <span class="input-group-append">
        <button class="btn btn-grey" type="button" @click="addExtras"><i class="d-block fe fe-plus"></i></button>
      </span>
    </div>
    <small class="d-block text-danger">{{ errors.first('credentials') }}</small>
    <div class="added-data">
      <div v-for="(data, index) in extrasArray" class="added-data__item" :key="data.id">
        {{ Object.keys(data)[0] }}: {{ data[Object.keys(data)[0]] }}<a href="javascript:void(0);" class="added-data__icon" @click="removeExtras(index)"><i class="fe fe-trash"></i></a>
      </div>
    </div>
	</div>
</template>

<script>
// @ is an alias to /src

export default {
	name: 'Extras',
	inject: ['$validator'],
	props: {
		dataList: Array
	},
	data() {
		return {
			extrasType: "",
			extrasValue: "",
			extrasArray: []
		}
	},
	mounted() {
		
	},
	methods: {
		addExtras: function() {
			if (this.extrasValue != "") {
				this.extrasArray.push({ [this.extrasType]: this.extrasValue });
				this.resetExtrasType();
				this.resetExtrasValue();
			}
		},
		removeExtras: function(index) {
			this.extrasArray.splice(index, 1);
		},
		resetExtrasType: function() {
			this.extrasType = "";
		},
		resetExtrasValue: function() {
			this.extrasValue = "";
		}
	},
	watch: {
		extrasArray: {
			handler: function() {
				this.$emit('update:value', this.extrasArray)
			},
			deep: true
		},
		dataList: function() {
			this.extrasArray = this.dataList;
			if(this.dataList.length != 0) {
				this.extrasType = "";
				this.extrasValue = "";
			}
		}
	}
}
</script>